import { useIntl } from "react-intl";
import * as yup from "yup";
import { parse } from "date-fns";
import messages from "./messages.i18n";
import { PeekInput } from "@piiqtechnologies/ui-components";
import { AccessDetailOption, AccessDetailsSelector, CalendarDateSelector } from "..";
export const EditRequestFormValidationSchema = () => {
    const intl = useIntl();
    return yup.object({
        availableFrom: yup
            .date()
            .transform((_value, originalValue) => parse(originalValue, "MM/dd/yy", new Date()))
            .typeError(intl.formatMessage(messages.editRequestAccessEarliestDateFormatError))
            .required(intl.formatMessage(messages.editRequestAccessEarliestDateError)),
        accessDetails: yup.string().required(intl.formatMessage(messages.editRequestAccessAccessDetailsError)),
        accessDetailsSpecifications: yup.string().when("accessDetails", {
            is: AccessDetailOption.OTHER,
            then: yup.string().required(intl.formatMessage(messages.editRequestAccessAccessDetailsSpecificationError)),
        }),
    });
};
export const DeleteRequestFormInitialValues = {
    cancellationReason: "",
};
export const EditRequestFormFields = ({ showAccessDetailsSpecifications }) => {
    const intl = useIntl();
    let accessDetails = [
        {
            id: "accessDetails",
            label: intl.formatMessage(messages.editRequestAccessDetailsLabel),
            placeholder: intl.formatMessage(messages.editRequestAccessDetailsPlaceholder),
            required: true,
            columns: 12,
            component: AccessDetailsSelector,
        },
    ];
    if (showAccessDetailsSpecifications) {
        accessDetails = [
            ...accessDetails,
            {
                id: "accessDetailsSpecifications",
                label: "",
                placeholder: intl.formatMessage(messages.editRequestAccessDetailsSpecifyPlaceholder),
                required: true,
                columns: 12,
                component: PeekInput,
                // @ts-ignore
                multiline: true,
                rows: 3,
            },
        ];
    }
    return {
        cancelRequest: {
            cancellationReason: [
                {
                    id: "reason",
                    label: intl.formatMessage(messages.cancellationReasonLabel),
                    placeholder: intl.formatMessage(messages.cancellationReasonLabel),
                    required: true,
                    columns: 12,
                    component: PeekInput,
                },
            ],
        },
        editRequest: {
            earliestDate: [
                {
                    id: "availableFrom",
                    label: intl.formatMessage(messages.editRequestEarliestDateLabel),
                    placeholder: intl.formatMessage(messages.editRequestEarliestDatePlaceholder),
                    required: true,
                    columns: 12,
                    top: 40,
                    left: 41.5,
                    component: CalendarDateSelector,
                },
            ],
            accessDetails: [...accessDetails],
            specialInstructions: [
                {
                    id: "specialInstructions",
                    label: intl.formatMessage(messages.editRequestAccessSpecialInstructionsLabel),
                    placeholder: intl.formatMessage(messages.editRequestAccessSpecialInstructionsPlaceholder),
                    required: false,
                    columns: 12,
                    component: PeekInput,
                },
            ],
        },
    };
};
